import React from "react";
import { DogApi, PersonApi } from "../../api";
import { useApiService } from "../useApiService";

export function usePersonValidators() {
  const personApi = useApiService(PersonApi);
  const dogApi = useApiService(DogApi);

  const isPersonAlive = React.useCallback(
    async (personId: number) => {
      const result = await personApi.isDeceased(personId);
      return !result.value;
    },
    [personApi]
  );

  const isNotOwnerOfExcludedKennel = React.useCallback(
    async (personId: number) => {
      const result = await personApi.checkIfOwnerofExcludedKennel(personId);
      return !result.value;
    },
    [personApi]
  );

  const isDogOwner = React.useCallback(
    async (dogId: number, personId: number) => {
      if (dogId !== 0) {
        const res = await dogApi.isBelgianDogOwner(dogId, personId);
        return res.value;
      }
      return true;
    },
    [dogApi]
  );

  const missingPhoneNumber = React.useCallback(
    async (personId: number) => {
      if (!!personId) {
        const result = await personApi.missingPhoneNumberCheck(personId);
        return result.value;
      }
      return true;
    },
    [personApi]
  );

  const missingAddress = React.useCallback(
    async (personId: number) => {
      if (!!personId) {
        const result = await personApi.missingAddressInformationCheck(personId);
        return result.value;
      }
      return true;
    },
    [personApi]
  );

  const kennelUnique = React.useCallback(
    async (personId: number) => {
      const res = await personApi.kennelOwnershipUniqueCheck(personId);
      return res.value;
    },
    [personApi]
  );

  return {
    isPersonAlive,
    isNotOwnerOfExcludedKennel,
    isDogOwner,
    missingPhoneNumber,
    missingAddress,
    kennelUnique,
  };
}
